import React, { useEffect } from 'react'

export const useOnClickOutside = (
  ref: React.RefObject<any>,
  handler: (event: any) => void,
  shouldStopOnLgReso?: boolean
) =>
  useEffect(() => {
    const listener = (event: any) => {
      if (
        !ref.current ||
        ref.current.contains(event.target) ||
        (shouldStopOnLgReso ? window.innerWidth < 1024 : false)
      ) {
        return
      }
      handler(event)
    }
    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)
    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler])
